import SubMenuRightContent from 'common-js/components/menu/SubMenuRightContent';
import TopMenu from 'common-js/components/menu/TopMenu';
import {
  USAGE,
  USAGE_BY_DAY,
  USAGE_EXITED_TESTING,
  USAGE_IN_TESTING,
  USAGE_LIVE,
  USAGE_TESTING_INVENTORY,
  pathMatches,
  pathMatchesNewUsageTab,
  withContext,
} from 'common-js/constants/paths';
import useAppSelector from 'common-js/hooks/useAppSelector';
import { selectHasPredeploymentTestingFlags } from 'common-js/reducers/releaseFlag/selectors';
import { type FC, type ReactNode } from 'react';

interface UsageMenuProps {
  children?: ReactNode;
}

const UsageMenu: FC<UsageMenuProps> = ({ children }) => {
  const isPreflight = useAppSelector(selectHasPredeploymentTestingFlags);
  const newUsageTabActive = pathMatchesNewUsageTab();

  return (
    <>
      <TopMenu titleHref={withContext(USAGE)} rightContent={<SubMenuRightContent />}>
        <TopMenu.Item
          text="Active SIMs"
          active={newUsageTabActive}
          href={withContext(USAGE_BY_DAY)}
        />
        {isPreflight && (
          <TopMenu.Item
            text="Pre-deployment SIMs"
            active={
              pathMatches(USAGE_IN_TESTING) ||
              pathMatches(USAGE_EXITED_TESTING) ||
              pathMatches(USAGE_TESTING_INVENTORY)
            }
            href={withContext(USAGE_IN_TESTING)}
          />
        )}
        <TopMenu.Item
          text="Recent sessions"
          active={pathMatches(USAGE_LIVE)}
          href={withContext(USAGE_LIVE)}
        />
      </TopMenu>
      {children}
    </>
  );
};

export default UsageMenu;
